<template>
    
<com-item :sortable="true" :date="item.date" :first="item.first" :last="item.last" :text="text" :thumb="item.image" :forceThumb="true" :name="item.name" v-on:up="$emit('up', item.id)" v-on:down="$emit('down', item.id)" v-on:edit="$emit('edit', item.id)" v-on:delete="$emit('delete', item.id)" />

</template>

<script>

import mixItem from '@/mixin/item.js'

export default {

    mixins: [mixItem]
    
}

</script>